export const NTT_MAP_BASE_URL = process.env.REACT_APP_NTT_MAP_BASE_URL || "https://d2bhiuln606fjb.cloudfront.net";